import React from 'react'
import { JobPreview as JobCardComponent } from '@superhi/design'

import { buildPath } from 'src/routing'
import { API } from 'src/api'

type ComponentProps = Omit<React.ComponentProps<typeof JobCardComponent>, 'description' | 'href'>

type Props = ComponentProps & API.JobCardComponent

const JobCard: React.FC<React.PropsWithChildren<Props>> = ({ slug, intro, ...props }) => {
  const href = React.useMemo(() => buildPath('jobs-view', { params: { slug } }), [slug])

  return <JobCardComponent {...props} headingLevel={2} href={href} description={intro} />
}

export { default as FRAGMENT } from './fragments'
export default JobCard
